import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "pages/Home";
import AboutPage from "pages/About";
import CareerPage from "pages/Career";
import PrivacyPage from "pages/Privacy";
import ScrollToTop from "functions/ScrollToTop";
import "ui/home/choose-us/three.css";
import Whatsapp from "components/whatsapp/whatsapp";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Whatsapp />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/career" element={<CareerPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
